import {
  GET_AUDIT_PLANS,
  GET_AUDIT_PLANS_SUCCESS,
  GET_AUDIT_PLAN_BY_ID,
  GET_AUDIT_PLAN_BY_ID_SUCCESS,
  POST_AUDIT_PLAN,
  PATCH_AUDIT_PLAN,
  DUPLICATE_AUDIT_PLAN,
  DELETE_AUDIT_PLAN,
  SUBMIT_AUDIT_PLAN,
  AUDIT_PLAN_IS_LOADING,
} from "./constants"

export function getAuditPlansAction(payload) {
  return {
    type: GET_AUDIT_PLANS,
    payload: payload,
  }
}

export function getAuditPlansSuccessAction(payload) {
  return {
    type: GET_AUDIT_PLANS_SUCCESS,
    payload: payload,
  }
}

export function getAuditPlanByIdAction(payload) {
  return {
    type: GET_AUDIT_PLAN_BY_ID,
    payload: payload,
  }
}

export function getAuditPlanByIdSuccessAction(payload) {
  return {
    type: GET_AUDIT_PLAN_BY_ID_SUCCESS,
    payload: payload,
  }
}

export function postAuditPlanAction(payload) {
  return {
    type: POST_AUDIT_PLAN,
    payload: payload,
  }
}

export function patchAuditPlanAction(payload) {
  return {
    type: PATCH_AUDIT_PLAN,
    payload: payload,
  }
}

export function duplicateAuditPlanAction(payload) {
  return {
    type: DUPLICATE_AUDIT_PLAN,
    payload: payload,
  }
}

export function deleteAuditPlanAction(payload) {
  return {
    type: DELETE_AUDIT_PLAN,
    payload: payload,
  }
}

export function submitAuditPlanAction(payload) {
  return {
    type: SUBMIT_AUDIT_PLAN,
    payload: payload,
  }
}

export function setAuditPlanIsLoadingAction(payload) {
  return {
    type: AUDIT_PLAN_IS_LOADING,
    payload: payload,
  }
}
